import React from "react";
import { Crown, Phone, Mail, Instagram, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#D4AF37]/15 bg-[#050505] px-6 md:px-12 lg:px-24 py-16"
      id="contact"
    >
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Crown className="w-6 h-6 text-[#D4AF37]" />
            <span className="font-serif text-xl">
              <span className="text-white">Luxury</span>{" "}
              <span className="gold-gradient-text font-medium">Kingz</span>
            </span>
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed max-w-xs">
            Premium photo booth experiences and curated travel — based in North Charleston, SC and serving the Lowcountry & beyond.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">Contact</h4>
          <ul className="space-y-3 text-zinc-300">
            <li>
              <a
                data-testid="footer-phone"
                href={CONTACT.phoneHref}
                className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
              >
                <Phone className="w-4 h-4" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email"
                href={CONTACT.emailHref}
                className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"
              >
                <Mail className="w-4 h-4" /> {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-zinc-400" data-testid="footer-location">
              <MapPin className="w-4 h-4" />{CONTACT.location}
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">Reserve</h4>
          <p className="text-zinc-400 text-sm mb-5">
            Limited dates each month. Secure your event today.
          </p>
          <Link to="/book" data-testid="footer-book-now" className="lk-btn-primary text-xs inline-block">
            Book Your Event
          </Link>
          <Link
            to="/find-booking"
            data-testid="footer-find-booking"
            className="block mt-4 text-xs uppercase tracking-widest text-zinc-400 hover:text-[#D4AF37]"
          >
            Find your booking →
          </Link>
          <a
            href="/#travel"
            data-testid="footer-travel-link"
            className="block mt-3 text-xs uppercase tracking-widest text-zinc-400 hover:text-[#D4AF37]"
          >
            Plan your travel →
          </a>
        </div>
      </div>

      <div className="border-t border-[#D4AF37]/10 mt-14 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
        <p className="text-xs text-zinc-500 tracking-wider">
          © {new Date().getFullYear()} Luxury Kingz LLC. All rights reserved.
        </p>
        <Link to="/admin/login" data-testid="admin-link" className="text-xs text-zinc-600 hover:text-[#D4AF37]">
          Admin
        </Link>
      </div>
    </footer>
  );
}
